const REPORT_TYPES = Object.freeze({
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
})

function expectedMime(file) {
  const name = String((file && file.name) || "")
  const extension = name.includes(".") ? name.split(".").pop().toLowerCase() : ""
  return Object.prototype.hasOwnProperty.call(REPORT_TYPES, extension) ? REPORT_TYPES[extension] : ""
}

export function reportFileMime(file) {
  const type = String((file && file.type) || "").trim().toLowerCase()
  return type && type !== "application/octet-stream" ? type : expectedMime(file)
}

export function isReportFile(file) {
  return Boolean(file && expectedMime(file) && reportFileMime(file) === expectedMime(file) &&
    Number.isInteger(file.size) && file.size > 0 && file.size <= 25 * 1024 * 1024)
}
